<template>
  <svg
    tabindex="0"
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    @click="emmitClick"
    @keyup="emmitClick"
  >
    <!-- eslint-disable-next-line -->
    <path fill="#FFF" fill-rule="evenodd" d="M28 18l-8 8-8-8 1.4-1.4 5.6 5.6V10h2v12.2l5.6-5.6L28 18zm-16 8h16v2H12v-2zm8 13c10.493 0 19-8.507 19-19S30.493 1 20 1 1 9.507 1 20s8.507 19 19 19zm0 1C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20z"/>
  </svg>
</template>

<script>
export default {
  name: 'RareIconDownload',
  methods: {
    emmitClick() {
      this.$emit('emmitClick');
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  svg:hover path {
    cursor: pointer;
    fill: $green-highlight;
  }

  svg:hover {
    cursor: pointer;
  }

</style>
